import { ActionLogDto, AdDto, ConfigDto, MenuDto, NewsDto, NewsTypeDto, RoleDto, UserDto, UserLoginDto } from "@/models/dtos"
import { BaseClass } from "./base"
import { ChangePswArgs, CreateAdArgs, CreateConfigArgs, CreateMenuArgs, CreateNewsArgs, CreateNewsTypeArgs, CreateRoleArgs, CreateUserArgs, LoginArgs, QueryActionLogArgs, QueryAdArgs, QueryMenuArgs, QueryNewsArgs, QueryNewsTypeArgs, QueryRoleArgs, QueryUserArgs, SetRoleMenuArgs, SetUserRoleArgs, UpdateUserSelfArgs } from "@/models/args"
import { ResponseDataType } from "@/models/types"

export class AccountClass extends BaseClass{
  login(data: LoginArgs){
    return this.post<UserLoginDto>('/api/Account/ManageLogin', data)
  }

  info(){
    return this.get<UserDto>('/api/Account/UserCache')
  }

  getCode(){
    return this.get<string>('/api/Account/GetScanCode')
  }

  getCodeState(key){
    return this.get<number>(`/api/Account/GetScanCodeState/${key}`)
  }

  scanLogin(key){
    return this.get<UserLoginDto>(`/api/Account/ScanLogin/${key}`)
  }
}

export class ActionLogClass extends BaseClass{
  gets(args: QueryActionLogArgs){
    return this.get<ResponseDataType<ActionLogDto>>('/api/ActionLog', args)
  }
}

export class AdClass extends BaseClass{
  gets(args: QueryAdArgs){
    return this.get<ResponseDataType<AdDto>>('/api/Ad', args)
  }

  create(data: CreateAdArgs){
    return this.post<number>('/api/Ad', data)
  }

  update(data: CreateAdArgs){
    return this.put<number>('/api/Ad', data)
  }

  remove(id: number){
    return this.delete<number>(`/api/Ad/${id}`)
  }

  state(id: number,status: number){
    return this.put<number>(`/api/Ad/SetActiveStatus/${id}/${status}`)
  }

  rank(id: number,rank: number){
    return this.get<number>(`/api/Ad/SetRank/${id}/${rank}`)
  }
}

export class ConfigClass extends BaseClass{
  gets(){
    return this.get<ConfigDto[]>('/api/Config')
  }

  create(data: CreateConfigArgs){
    return this.post<number>('/api/Config', data)
  }

  update(data: CreateConfigArgs[]){
    return this.put<number>('/api/Config', data)
  }
}

export class MenuClass extends BaseClass{
  gets(args: QueryMenuArgs){
    return this.get<ResponseDataType<MenuDto>>('/api/Menu', args)
  }

  create(data: CreateMenuArgs){
    return this.post<number>('/api/Menu', data)
  }

  update(data: CreateMenuArgs){
    return this.put<number>('/api/Menu', data)
  }

  menus(){
    return this.get<MenuDto[]>('/api/Menu/GetUserRoleMenus')
  }

  sort(id: number,sort: number){
    return this.get<number>(`/api/Menu/UpdateSort/${id}/${sort}`)
  }
}

export class NewsClass extends BaseClass{
  gets(args: QueryNewsArgs){
    return this.get<ResponseDataType<NewsDto>>('/api/News', args)
  }

  create(data: CreateNewsArgs){
    return this.post<number>('/api/News', data)
  }

  update(data: CreateNewsArgs){
    return this.put<number>('/api/News', data)
  }

  remove(id: number){
    return this.delete<number>(`/api/News/${id}`)
  }

  state(id: number,status: number){
    return this.put<number>(`/api/News/ChangePublishStatus/${id}/${status}`)
  }

  top(id: number,status: number){
    return this.put<number>(`/api/News/ChangeIsTop/${id}/${status}`)
  }

  home(id: number,status: boolean){
    return this.put<number>(`/api/News/ChangeIsHomeShow/${id}/${status}`)
  }
}

export class NewsTypeClass extends BaseClass{
  gets(args: QueryNewsTypeArgs){
    return this.get<ResponseDataType<NewsTypeDto>>('/api/NewsType', args)
  }

  create(data: CreateNewsTypeArgs){
    return this.post<number>('/api/NewsType', data)
  }

  update(data: CreateNewsTypeArgs){
    return this.put<number>('/api/NewsType', data)
  }

  remove(id: number){
    return this.delete<number>(`/api/NewsType/${id}`)
  }
}

export class RoleClass extends BaseClass{
  gets(args: QueryRoleArgs){
    return this.get<ResponseDataType<RoleDto>>('/api/Role', args)
  }

  create(data: CreateRoleArgs){
    return this.post<number>('/api/Role', data)
  }

  update(data: CreateRoleArgs){
    return this.put<number>('/api/Role', data)
  }

  remove(id: number){
    return this.delete<number>(`/api/Role/${id}`)
  }

  all(){
    return this.get<RoleDto[]>('/api/Role/GetAllRoles')
  }

  setMenus(id: number, menuIdList: SetRoleMenuArgs){
    return this.put<number>(`/api/Role/${id}`, menuIdList)
  }
}

export class UserClass extends BaseClass{
  gets(args: QueryUserArgs){
    return this.get<ResponseDataType<UserDto>>('/api/User', args)
  }

  create(data: CreateUserArgs){
    return this.post<number>('/api/User', data)
  }

  update(data: UpdateUserSelfArgs){
    return this.put<number>('/api/User/Self', data)
  }

  remove(id: string){
    return this.delete<number>(`/api/User/${id}`)
  }

  setRoles(data: SetUserRoleArgs){
    return this.post<number>('/api/User/SetUserRole', data)
  }

  setPsw(data: ChangePswArgs){
    return this.post<number>('/api/User/ChangePsw', data)
  }

  setAllow(id: string, state: number){
    return this.get<number>(`/api/User/AllowLogin/${id}/${state}`)
  }

  auth(id: string, state: boolean){
    return this.get<number>(`/api/User/Auth/${id}/${state}`)
  }

  excel(args: QueryUserArgs){
    return this.export('/api/User/Export','GET', args)
  }
}